<template>
  <div>
    <menu-item
      :item="menu"
      :key="menu.id"
      v-for="menu in menus"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import MenuItem from '@/components/menu/MenuItem';
import MenuItemMixin from '@/mixins/MenuItemMixin';

export default {
  name: 'OwnerMenu',

  mixins: [
    MenuItemMixin,
  ],

  components: {
    MenuItem,
  },

  computed: {
    ...mapGetters('subscription', {
      saasSubscription: 'GET_SAAS_SUBSCRIPTION',
    }),
    ...mapGetters('user', {
      readOnly: 'GET_READONLY_INFO',
    }),

    canShowSaasItems() {
      return this.hasSaasSubscription
          && this.readOnly?.ownerSaasId
          || this.readOnly?.saasRole
          && this.readOnly?.saasRole !== 'user';
    },

    hasSaasSubscription() {
      return !!this.saasSubscription;
    },

    isOwnerMarketplaceEnabled() {
      return this.readOnly?.isDoctorMarketplaceEnabled || false;
    },

    menus() {
      return [
        {
          active: this.isActive('owner-saas-subscription'),
          color: 'blue',
          icon: 'mdi-file-document',
          title: 'Assinatura',
          to: 'owner-saas-subscription',
        },
        {
          icon: 'mdi-speedometer',
          color: 'blue',
          title: this.$t('menu.ownerDashboard'),
          to: 'owner-dashboard',
          active: this.isActive('owner-dashboard'),
        },
        {
          icon: 'mdi-calendar-month',
          color: 'purple',
          title: this.$t('menu.calendar.owner'),
          to: 'owner-calendar',
          active: this.isActive('owner-calendar'),
        },
        {
          icon: 'mdi-calendar-week',
          color: 'green',
          title: this.$t('menu.events'),
          to: 'owner-spaces-events',
          active: this.isActive('owner-spaces-events'),
        },
        {
          icon: 'mdi-domain',
          color: 'orange',
          title: this.$t('menu.myProperties'),
          to: 'owner-unities',
          active: this.isActive('owner-unities'),
        },
        {
          color: 'purple',
          disabled: true,
          icon: 'mdi-wallet-giftcard',
          soon: true,
          title: this.$t('menu.opportunities'),
          to: '/owner-opportunities',
        },
        {
          color: 'blue',
          disabled: !this.isOwnerMarketplaceEnabled,
          icon: 'mdi-shopping',
          soon: true,
          title: this.$t('menu.marketplace'),
          to: '/owner-marketplace',
        },
        {
          active: this.isActive('owner-marketplace'),
          color: 'blue',
          icon: 'mdi-shopping',
          soon: true,
          title: this.$t('menu.marketplace'),
          to: 'owner-marketplace',
        },
      ].filter(Boolean);
    },
  },
}
</script>
